import React, { useEffect, useState } from 'react';
import { NavLink, useSearchParams } from 'react-router-dom';

import { list as listProducts, create as createProduct } from '../../apis/products';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { usePagination } from '../../hooks/usePagination';
import { useApiQuery } from '../../hooks/useApiQuery';
import { useModal } from '../../hooks/useModal';

import { ActionButton } from '../../components/common/buttons/ActionButton';
import { AdminBreadcrumb } from '../../components/admin/AdminBreadcrumb';
import { ProductsList } from '../../components/products/ProductsList';
import { FormModal } from '../../components/common/form/FormModal';
import { ProductForm } from '../../components/products/ProductForm';

export const AdminProductsPage = () => {
    useDocumentTitle('Admin Products');

    const ProductFormModal = (props) => {
        const handleSuccess = () => {
            handlers.onRefresh();
        };
        return (
            <FormModal
                notificationTitle="Products"
                notificationIcon="icons"
                onSucceed={handleSuccess}
                action={createProduct}
                form={ProductForm}
                title="Create product"
                mode="create"
                {...props}
            />
        );
    };

    const [searchParams, setSearchParams] = useSearchParams();
    const initialFilter = searchParams.get('filter') || '';
    const [filter, setFilter] = useState(initialFilter);

    const { pagination, setPagination, handlers } = usePagination({ page: 1, size: 5 });
    const products = useApiQuery(listProducts, pagination);
    const { showModal, handleShow, handleHide } = useModal();

    useEffect(() => {
        setPagination({
            page: 1,
            size: 5,
            filter
        });
    }, [initialFilter]);

    const handleSubmitFilter = (event) => {
        event.preventDefault();
        setSearchParams({ filter });
    };

    const handleResetFilter = () => {
        setSearchParams({});
        setFilter('');
    };

    return (
        <div className="admin-products-page mb-5">
            <h1 className="h3">Products</h1>
            <AdminBreadcrumb>
                <NavLink className="breadcrumb-item text-decoration-none" to="/admin/products">
                    Products
                </NavLink>
            </AdminBreadcrumb>
            <div className="row mb-3">
                <div className="col-sm-6 col-md-9 col-lg-10 mb-3 mb-sm-0">
                    <form
                        onSubmit={handleSubmitFilter}
                        onReset={handleResetFilter}
                        className="input-group">
                        <input
                            type="text"
                            value={filter}
                            placeholder="Filter"
                            className="form-control"
                            onChange={(e) => setFilter(e.target.value)}
                        />
                        <button className="btn btn-outline-secondary" type="reset">
                            <span className="fas fa-eraser fa-fw"></span>
                        </button>
                        <button className="btn btn-outline-primary" type="submit">
                            <span className="fas fa-search fa-fw"></span>
                        </button>
                    </form>
                </div>
                <div className="col-sm-6 col-md-3 col-lg-2 mb-3 mb-sm-0">
                    <div className="d-grid">
                        <ActionButton onClick={handleShow} className="btn btn-primary">
                            New
                        </ActionButton>
                        <ProductFormModal show={showModal} onHide={handleHide} />
                    </div>
                </div>
            </div>
            <ProductsList onReset={handleResetFilter} {...{ ...products, handlers }} />
        </div>
    );
};
